<template>
  <PageTemplate v-if="isAuthenticated()">
    <h1>Contact NATA</h1>
    <div class="row">
      <div class="col-md-9">
        <v-card title="Send us an email">
          <template v-if="hasSent">
            <h2>Thank you for your enquiry!</h2>
            <p>We have received your message and will get back to you shortly.</p>
            <p>
              If you have asked for changes to be made to your account, they will have to be approved by NATA before
              the
              changes are implemented.
            </p>
            <v-button-group>
              <v-button
                color="secondary"
                size="lg"
                has-min-width
                @click="hasSent = false"
              >
                Make another enquiry
              </v-button>
              <v-button
                link="/#/dashboard"
                size="lg"
                has-min-width
              >
                Go to your dashboard
              </v-button>
            </v-button-group>
          </template>
          <template v-else>
            <p>
              <strong>
                You can use this page to send us any changes that you need to be made to your account or to ask us any
                questions.
                <br>
                When asking for changes, please list what you would like changed in as much detail as possible.
              </strong>
            </p>
            <v-contact-form @sent="hasSent = true" />
          </template>
        </v-card>
      </div>
      <div class="col-md-3">
        <v-card title="Get in Contact">
          <v-list
            has-icons
            :items="contact"
          />
        </v-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 d-flex">
        <strong>Notes:</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 d-flex">
        <ul>
          <li>
            To change the appointed Authorised Representative or Facility details please complete the <a
              href="https://www.nata.com.au/phocadownload/gen-accreditation-forms/Facility-Details-Update-Form-FDU.pdf"
              target="_blank"
              class="btn--secondary"
              download="Facility-Details-Update-Form-FDU.pdf"
            >Facility Details Update (FDU)</a> form and upload it on the Portal at the Site level or email us the form on <a
              :href="getEmail(true)"
              class="btn--secondary"
            >{{ getEmail() }}</a>.
          </li>
        </ul>
      </div>
    </div>
  </PageTemplate>
  <Login
    v-else
    title="Contact NATA"
  >
    <v-contact-form class="mb-2" />
    <v-button
      color="transparent"
      @click="$router.push('/login/')"
    >
      Back to login
    </v-button>
  </Login>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import List from "@/molecules/List";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import ContactForm from "@/templates/ContactForm";
  import Login from "@/templates/Login";
  import {buildBreadCrumb} from "@/common/tableFunctions";
  import TokenService from "@/common/tokenService";
  import constants from "@/common/constants";
  import routes from "@/common/routes";

  export default {
    name: "Contact",
    components: {
      'v-list': List,
      'v-card': Card,
      'v-button': Button,
      'v-button-group': ButtonGroup,
      'v-contact-form': ContactForm,
      PageTemplate,
      Login,
    },
    data: () => ({
      hasSent: false,
      contact: [
        {value: constants.NATA_CONTACTS.PHONE, icon: 'phone', link: 'tel:'+constants.NATA_CONTACTS.PHONE_LINK},
        {value: constants.NATA_CONTACTS.EMAIL, icon: 'envelope', link: 'mailto:'+constants.NATA_CONTACTS.EMAIL},
        {value: constants.NATA_CONTACTS.ADDRESS, icon: 'map-marker', link: constants.NATA_CONTACTS.ADDRESS_LINK, target: '_blank'},
        {value: constants.NATA_CONTACTS.WEBSITE, icon: 'user', link: constants.NATA_CONTACTS.WEBSITE_LINK, target: '_blank'},
      ]
    }),
    mounted() {
      this.updateBreadCrumb();
    },
    methods: {
      isAuthenticated() {
        return !!TokenService.getToken();
      },
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Contact NATA'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getEmail(isLink) {
        if(isLink)
          return "mailto:"+constants.NATA_CONTACTS.EMAIL;
        return constants.NATA_CONTACTS.EMAIL;
      }
    }
  }
</script>

